export const uz = {
  'language.az': 'Azərbaycanca',
  'language.en': 'English',
  'language.hu': 'Magyar',
  'language.ko': '한국어',
  'language.pt': 'Português',
  'language.ru': 'Русский',
  'language.tr': 'Türkçe',
  'language.uz': 'Oʻzbek',

  'order': 'Buyurtma {order}',
  'amount': '{amount}',

  'card.sample.expiry': 'OO / YY',
  'card.sample.name': 'ISM FAMILIYA',

  'card.pan': 'Karta raqami',
  'card.owner': 'Kartada ko‘rsatilgan ism va familiya',
  'card.expiry': 'OO / YY',
  'card.cvc': 'CVC',
  'card.captcha_text': 'Rasmdagi belgilarni kiriting',

  'card.btn.pay': 'To‘lash',

  'card.error.pan.required': 'Maydonni to‘ldiring.',
  'card.error.pan.invalid': 'Karta raqami noto‘g‘ri.',
  'card.error.name.invalid': 'Faqat lotin harflari, bo‘shliq, nuqta va tire (30 tagacha).',
  'card.error.name.fullname': 'Ism va familiyani kiriting.',
  "card.error.pan.whitelist": "Faqat quyidagi kartalar mavjud: {list}.",
  'card.error.name.required': 'Maydonni to‘ldiring.',
  'card.error.cvc.required': 'Maydonni to‘ldiring.',
  'card.error.cvc.invalid': 'Maydonni to‘ldiring.',
  'card.error.expiry.required': 'Maydonni to‘ldiring.',
  'card.error.expiry.month.invalid': 'Qiymat 01 dan 12 gacha bo‘lishi kerak.',
  'card.error.expiry.year.invalid': 'Joriy yoki keyingi yillar.',
  'card.error.captcha_text.required': 'Maydonni to‘ldiring.',

  'card.protected.caption.title': 'Maʼlumotlaringiz himoyalangan',
  'card.protected.caption.desc': 'Bank kartasi rekvizitlari himoyalangan protokollar orqali uzatiladi va internet-do‘konga hamda uchinchi shaxslarga berilmaydi. To‘lovlar PCI DSS standartiga muvofiq himoyalangan protsessing sahifasida qayta ishlanadi.',

  'card.sending.preloader.title': 'Oynani yopmang va sahifani yangilamang',
  'card.sending.preloader.desc': 'Biz havola yaratmoqdamiz. Bu bir necha soniyadan bir daqiqagacha vaqt olishi mumkin.',

  'fatal_errors': 'Rad etilish sababi:',

  'card.processing.1': 'Maʼlumotlarni tayyorlash',
  'card.processing.2': 'To‘lov imkoniyatini tekshirish',
  'card.processing.3': 'To‘lovni amalga oshirish',

  'finish.pending': 'To‘lov qayta ishlanmoqda',
  'finish.pending.desc': 'To‘lovingiz qayta ishlashga qabul qilindi. Ushbu oynani yoping va do‘konga qayting.',
  'finish.new': 'To‘lov kutilmoqda',
  'finish.new.desc': 'To‘lovingiz qayta ishlashga qabul qilindi. Ushbu oynani yoping va do‘konga qayting.',
  'finish.complete': 'To‘lov qabul qilindi',
  'finish.complete.desc': 'To‘lov muvaffaqiyatli amalga oshirildi. Ushbu oynani yoping va do‘konga qayting.',
  'finish.failed': 'To‘lov rad etildi',
  'finish.failed.desc': 'Iltimos, qayta to‘lash uchun do‘konga qayting.',
  'finish.refunded': 'To‘lov qaytarildi',
  'finish.refunded.desc': ' ',
  'finish.exception': 'Nimadir noto‘g‘ri ketdi',
  'finish.exception.desc': ' ',

  'finish.debug_info': 'Qo‘llab-quvvatlash xizmatiga murojaat qilish uchun maʼlumot',
  'return.btn.return': 'Do‘konga qaytish',

  'error.general': 'Nimadir noto‘g‘ri ketdi... yana urinib ko‘ring.',
}
